
export const DASHBOARD_TYPE_URL_PREFIX_MAP = {
  custom: '/dashboards',
  journal: '/dashboards/journal',
  institution: '/dashboards/funding-institution',
  affiliation: '/dashboards/institution'
}
